import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { SvgSelect, SecondaryBtn } from '@tmapy/style-guide';
import { actionActivateEditTool, actionDeactivateTools } from '../actions';
export const EditToolBtn = ({ isActive, dispatch, children }) => {
    const handleClick = useCallback(() => {
        if (isActive) {
            dispatch(actionDeactivateTools());
        }
        else {
            dispatch(actionActivateEditTool());
        }
    }, [dispatch, isActive]);
    return (_jsx(SecondaryBtn, { icon: { element: _jsx(SvgSelect, {}) }, isActive: isActive, tooltip: children, onClick: handleClick }));
};
//# sourceMappingURL=EditToolBtn.js.map